import Checkbox from "@/common/elements/InputElements/CheckBox";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { Form } from "antd";
import { forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import { SCHEMA_NAME } from "@/util/common_variable";

const ActiveStaffMemberForm = forwardRef(
  ({ bookingsFieldsEnabled, startingPoint = "Bookings" }, ref) => {
    const dispatch = useDispatch();
    const { bookings } = useSelector((s) => s?.bookings);

    const changeIsActive = (e) => {
      dispatch(setBookings({ isActive: e?.target?.checked }));
    };

    return (
      <FieldSecurityProvider
        entity={SCHEMA_NAME.BIO}
        startingPoint={startingPoint}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      >
        <Form disabled={!bookingsFieldsEnabled}>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={12} xl={8}>
              <SecureFormItem
                fieldName="isActive"
                formItemProps={{
                  label: "Active Staff Member?",
                  layout: "horizontal",
                  labelPostion: "label-right",
                  className: "checkbox-control",
                  valuePropName: "checked",
                }}
              >
                <Checkbox
                  checked={bookings?.isActive}
                  onChange={changeIsActive}
                />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </FieldSecurityProvider>
    );
  }
);

export default ActiveStaffMemberForm;
